module.exports = __webpack_public_path__ + "media/images/landing/bg/shape-a205415a94a974f1520bf4dde2b2463d.png";